var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-settings"},[_c('b-container',{staticClass:"bg-settings mt-4"},[_c('b-row',[_c('b-col',{staticClass:"d-flex align-items-center",attrs:{"cols":"12"}},[_c('div',{staticClass:"p2"},[_c('span',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.title))])])])],1)],1),_c('StoryInsightsForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }